import { render } from "./SendAuthCode.vue?vue&type=template&id=91d1f44c"
import script from "./SendAuthCode.vue?vue&type=script&lang=js"
export * from "./SendAuthCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__